<template>
    <div>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">

            <h2 class="text-center">Cadastrar usuário</h2>

            <b-form-group label="Nome Completo:">
                <b-form-input
                v-model="form.fullname"
                required
                placeholder="Digite o nome completo"
                ></b-form-input>
            </b-form-group>
            <!-- description="We'll never share your email with anyone else." -->
            <b-form-group
                label="Email:"
            >
                <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Digite o email"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Função:">
                <b-form-select
                v-model="form.role"
                :options="roles"
                required
                ></b-form-select>
            </b-form-group>

            <b-form-group
                label="Senha:"
            >
                <b-form-input
                v-model="form.password"
                type="password"
                required
                placeholder="Digite a senha"
                ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4">
                <b-form-checkbox-group v-model="form.checked">
                    <b-form-checkbox value="yes">Enviar E-mail</b-form-checkbox>
                </b-form-checkbox-group>
            </b-form-group>

            <div class="text-center">
                <b-button type="submit" variant="primary">Salvar</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="reset" variant="danger">Limpar</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="button" variant="warning" @click="goBack()">Voltar</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'User',
    data() {
      return {
        form: {
          email: '',
          fullname: '',
          password: '',
          role: 'Usuário',
          sendemail: ''
        },
        roles: [
            { text: 'Selecione', value: null }, 
            'Administrador', 
            'Usuário',
        ],
        show: true
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        alert(JSON.stringify(this.form))
      },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form = {
            email: '',
            fullname: '',
            password: '',
            role: 'Usuário',
            sendemail: ''
        }
        // this.form.name = ''
        // this.form.food = null
        // this.form.checked = []
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    }
}
</script>

<style>

</style>